import React from "react";
import FilterPanel from "./FilterPanel";
import StatsPanel from "./StatsPanel";

const SidePanel = ({
  statusFilter,
  tipoIstanzaFilter,
  useStatusFilter,
  useTipoIstanzaFilter,
  useProximityFilter,
  proximityRange,
  userLocation,
  customLocation,
  useCustomLocation,
  isSelectingLocation,
  loadingLocation,
  filteredOrgCoords,
  totals,
  orgCoords,
  handleStatusChange,
  handleTipoIstanzaChange,
  handleProximityRangeChange,
  setUseProximityFilter,
  useMyLocation,
  startCustomLocationSelection,
  filtering,
  showCompetitors,
  setShowCompetitors,
  showPartners,
  setShowPartners
}) => {
  return (
    <div style={{ height: '100%' }}>
      <FilterPanel 
        statusFilter={statusFilter}
        tipoIstanzaFilter={tipoIstanzaFilter}
        useStatusFilter={useStatusFilter}
        useTipoIstanzaFilter={useTipoIstanzaFilter}
        useProximityFilter={useProximityFilter}
        proximityRange={proximityRange}
        userLocation={userLocation}
        customLocation={customLocation}
        useCustomLocation={useCustomLocation}
        isSelectingLocation={isSelectingLocation}
        loadingLocation={loadingLocation}
        handleStatusChange={handleStatusChange}
        handleTipoIstanzaChange={handleTipoIstanzaChange}
        handleProximityRangeChange={handleProximityRangeChange}
        setUseProximityFilter={setUseProximityFilter}
        useMyLocation={useMyLocation}
        startCustomLocationSelection={startCustomLocationSelection}
        filtering={filtering}
        showCompetitors={showCompetitors}
        setShowCompetitors={setShowCompetitors}
        showPartners={showPartners}
        setShowPartners={setShowPartners}
      />
      
      <StatsPanel 
        filteredOrgCoords={filteredOrgCoords}
        totals={totals}
        orgCoords={orgCoords}
        filtering={filtering}
      />
    </div>
  );
};

export default SidePanel; 